// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#carousel[data-v-145cce0a]{width:100%;height:.8rem;line-height:.8rem;margin-top:.1rem}.van-notice-bar[data-v-145cce0a]{padding-right:.3rem;font-size:.26rem}.van-icon-volume-o[data-v-145cce0a]{font-size:.28rem!important}.notice-swipe[data-v-145cce0a]{height:.4rem;line-height:.4rem}", ""]);
// Exports
module.exports = exports;
